import { useCallback, useState } from "react";
import Store from "logic/local-storage/Store";
import usePersistedSetting from "hooks/usePersistedSetting";
import useBrowserColorSchemePreference from "./useBrowserColorSchemePreference";
import {
  COLOR_SCHEME_DARK,
  COLOR_SCHEME_LIGHT,
  DEFAULT_THEME_MODE,
  LEGACY_COLOR_SCHEME_DARK,
  LEGACY_COLOR_SCHEME_LIGHT,
  PREFERENCES_THEME_MODE
} from "../constants";
const fromLegacyColorSchemeName = (legacyColorScheme) => {
  if (legacyColorScheme === LEGACY_COLOR_SCHEME_LIGHT) {
    return COLOR_SCHEME_LIGHT;
  }
  if (legacyColorScheme === LEGACY_COLOR_SCHEME_DARK) {
    return COLOR_SCHEME_DARK;
  }
  return legacyColorScheme;
};
const getInitialThemeMode = ({
  userPreferencesThemeMode,
  browserThemePreference,
  initialThemeModeOverride,
  userIsLoggedIn
}) => {
  var _a;
  if (initialThemeModeOverride) {
    return initialThemeModeOverride;
  }
  if (!userIsLoggedIn) {
    return DEFAULT_THEME_MODE;
  }
  const userThemePreference = userPreferencesThemeMode != null ? userPreferencesThemeMode : fromLegacyColorSchemeName(Store.get(PREFERENCES_THEME_MODE));
  return (_a = userThemePreference != null ? userThemePreference : browserThemePreference) != null ? _a : DEFAULT_THEME_MODE;
};
const usePreferredColorScheme = (initialThemeModeOverride, userIsLoggedIn) => {
  const browserThemePreference = useBrowserColorSchemePreference();
  const [themeMode, setThemeMode] = usePersistedSetting(PREFERENCES_THEME_MODE);
  const [currentThemeMode, setCurrentThemeMode] = useState(
    () => getInitialThemeMode({
      userPreferencesThemeMode: themeMode,
      browserThemePreference,
      initialThemeModeOverride,
      userIsLoggedIn
    })
  );
  const changeCurrentThemeMode = useCallback(
    (newThemeMode) => {
      setCurrentThemeMode(newThemeMode);
      if (userIsLoggedIn) {
        setThemeMode(newThemeMode);
      }
    },
    [setThemeMode, userIsLoggedIn]
  );
  return [currentThemeMode, changeCurrentThemeMode];
};
export default usePreferredColorScheme;
